<template>
    <md-toolbar class="main-toolbar ql-project-sub-header">
        <project-tools-palette 
            :bookmarkNavOpened="bookmarkNavOpened"
            :historyIndex="historyIndex"
            :history="history"
            @updateHistory="updateHistory"
            :listView="listView"
            @toggleBookmarkNav="toggleBookmarkNav"
            :currentPage="currentPage" 
            :selectedElement="selectedElement"
            :selectedPageRenameIndices="selectedPageRenameIndices"
            @thumbnailSelectionClick="thumbnailSelectionClick"
            @setSelectedElement="setSelectedElement"
            @pasteCueNote="pasteCueNote"
            @copyElement="copyElement"
            @setScale="setScale"
            @pageUp="pageUp"
            @pageDown="pageDown" 
            :locked="locked"
            @setPage="setPage"
            :pageHeight="pageHeight"
            :pageWidth="pageWidth"
            :pageFollow="pageFollow"
            @setFollowUid="setFollowUid"
        />
    </md-toolbar>
</template>

<script>
import firebase from 'firebase/app';
import { mapGetters } from 'vuex';

import NavBus from '@/buses/nav';
import ProjectPagination from '@/components/project/pagination';
import ProjectSearch from '@/components/project/search';
import ProjectToolsPalette from '@/components/project/palette';

const ProjectHeader = {
    name: 'projectSubHeader',
    props: [
        'user',
        'currentPage',
        'locked',
        'isOwner',
        'bookmarkNavOpened',
        'listView',
        'selectedElement',
        'historyIndex',
        'history',
        'selectedPageRenameIndices',
        'pageWidth',
        'pageHeight',
        'pageFollow'
    ],
    data: function() {
        return {
            connected: true
        };
    },
    computed: {
        ...mapGetters([
            'currentVersion',
            'projectTitle'
        ])
    },
    methods: {
        setScale(value) {
            this.$emit('setScale', value);
        },
        thumbnailSelectionClick(value) {
            this.$emit('thumbnailSelectionClick', value);
        },
        setSelectedElement(data) {
            this.$emit('setSelectedElement', data);
        },
        updateHistory(data) {
            this.$emit('updateHistory', data);
        },
        toggleLeftSidenav() {
            NavBus.$emit('main-nav.open');
        },
        pasteCueNote() {
            this.$emit('pasteCueNote');
        },
        copyElement() {
            this.$emit('copyElement');
        },
        pageDown() {
            this.$emit('pageDown', this.currentPage);
        },
        pageUp() {
            this.$emit('pageUp', this.currentPage);
        },
        setPage(number) {
            this.$emit('setPage', number);
        },
        setFollowUid(uid) {
            this.$emit('setFollowUid', uid);
        },
        toggleBookmarkNav() {
            this.$emit('toggleBookmarkNav');
        },
        toggleWorkNoteNav() {
            NavBus.$emit('worknote-nav.toggle');
        },
        expandAll() {
        },
        contractAll() {
        },
        handleKeyDown(e) {
            // Ctrl+Alt+W is handled by header.vue alone: it is always mounted, and handling it here too toggled the
            // Work Notes panel twice in PDF view (open, then straight back closed).
            if (e.ctrlKey && e.altKey && e.code === 'KeyB') {
                this.toggleBookmarkNav();
                e.preventDefault();
            }
        }
    },
    mounted: function () {
        const connectedRef = firebase.database().ref('.info/connected');
        connectedRef.on('value', (snap) => {
            if (snap.val() === true) {
                this.connected = true;
            } else {
                this.connected = false;
            }
        });
        document.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy: function() {
        document.removeEventListener('keydown', this.handleKeyDown);
    },
    components: {
        'project-pagination': ProjectPagination,
        'project-search': ProjectSearch,
        'project-tools-palette': ProjectToolsPalette
    }
};

export default ProjectHeader;
</script>

<style lang="scss">
.md-toolbar.main-toolbar.ql-project-sub-header {
    flex: 1;
    flex-wrap: nowrap;
    background-color: #fff!important;
    color: #aca3a3;
    font-weight: 500;
}

/* START DARK THEME CODE */
.md-theme-show-mode .md-toolbar.main-toolbar.ql-project-sub-header {
    background-color: rgba(255,255,255,0.1) !important;
}
/* END DARK THEME CODE */
</style>



// WEBPACK FOOTER //
// sub-header.vue?5abacf64